import { ApiEndpoints } from "@shared/api/api-endpoints";
import { axApiClient } from "@shared/api/clients/apiClientFactory";

export const axDashboardApi = {
  getAllTabsDashboardData: async (tabName: string, remoteUtilityId: string) => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "ax",
      `dashboard/${tabName}`,
      (query) => {
        query.push("remote_utility_id", remoteUtilityId);
        return query;
      }
    );
    const response = await axApiClient.get(url);
    return response.data ?? [];
  },
    getFinancialData: async (params: {
    remote_utility_id: string;
    date_filter: string;
  }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "ax",
      "dashboard/financial",
      (qs) => {
        qs.push("remote_utility_id", params.remote_utility_id);
        qs.push("date_filter", params.date_filter);
      }
    );
    const response = await axApiClient.get(url);
    return response.data;
  },
};
